import { atom } from 'jotai';

/** 사용자 현재 위치. 앱이 아직 위치를 받지 못했으면 0 */
export const userLatLonAtom = atom<{
    lat: number,
    lon: number
}>({
    lat: 0,
    lon: 0,
});

export const locationAgreedAtom = atom<boolean>(false);

/** userLatLonAtom 을 마지막으로 갱신한 시각(ms). 미리 받아둔 위치의 유효성 판단에 쓴다. */
export const locationFetchedAtAtom = atom<number>(0);

/** 미리 받아둔 위치를 재사용하는 시간 */
export const LOCATION_CACHE_MS = 5 * 60 * 1000;
